import { Icon, Popover } from '@blueprintjs/core'
import { css as classname } from 'emotion'
import { uniqueId } from 'lodash'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { OverlayProps } from '../../../../../helper/configs'
import { globalOnDemandVars } from '../../../../../helper/context'
import EditorForUploadType2 from '../../../../list/uploadType2/editor'
// import EditorForUploadType2 from '../../../../list/uploadType2/editor'
import { InsertFormObject } from './insertFormRegister'

function ThumbNail ({ displayEdit, displayPreview, item, ...props }) {
  const InsertForm = useMemo(() => (InsertFormObject[item.type]), [item.type])

  const [forceUpdate, setForceUpdate] = useState(0)
  useEffect(() => {
    // TODO 여기서 setThumbNailForceUpdate 가 제대로 작동하고있나?
    if (item.setThumbNailForceUpdate) {
      const newId = uniqueId()
      item.setThumbNailForceUpdate(newId, () => {
        setForceUpdate(uniqueId())
      })
      return () => {
        item.deleteThumbNailForceUpdate(newId)
      }
    }
  }, [item])

  const onClick = useCallback(
    () => {
      if (item.isType3) {
        globalOnDemandVars.openGlobalDialog()(item.type, <EditorForUploadType2 id={item.id} window1Id={'notFromTree'} forType3 />, 'bigger')
      } else {
        globalOnDemandVars.openGlobalDialog()(item.type, <InsertForm.EditDialog item={item} />, 'bigger')
      }
    },
    [item]
  )

  const hasFragment = useMemo(() => {
    return (item.isType3 && item.fragmentList && item.fragmentList.length)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.fragmentList, item.isType3, forceUpdate])

  const { t } = useTranslation()

  // TODO content 가 바뀐 후에 여러 썸네일들이 반영이 되나?
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const thumbnailContent = useMemo(() => (<InsertForm.ThumbNailBase contentData={item.content} {...props} />), [item.content, props, forceUpdate])

  return useMemo(() => (
    // <WrapperForLoader content={
    //   <Popover content={<div css={css`max-width: 50vw; max-height: 50vh; overflow: auto; position: relative;`} className={hasScrollbarAlways}><Render contentData={item.content} /></div>} popoverClassName={classname`background-color: white;`} disabled={!displayPreview} interactionKind='hover' position='auto' {...OverlayProps}>
    //     <div className={'mediaThumbnail'} title={displayEdit ? 'Click to edit' : null} onMouseDown={onClick} css={css`cursor: ${displayEdit ? 'pointer' : ''}; overflow: hidden;`}><ThumbNailBase contentData={item.content} {...props} /></div>
    //   </Popover>
    // } />
    <Popover
      content={<div css={css`max-width: 50vw; max-height: 50vh; overflow: auto; position: relative;`}><InsertForm.Render contentData={item.content} /></div>}
      popoverClassName={classname`background-color: var(--baseColor);`} disabled={!displayPreview}
      interactionKind='hover' position='auto' {...OverlayProps}>
      <div className={'mediaThumbnail'} title={displayEdit ? t('Click to edit') : null} onMouseDown={onClick}
        css={css`cursor: ${displayEdit ? 'pointer' : ''};
${hasFragment ? 'border-bottom: var(--s-3) solid var(--answerColor);' : ''}
`}>
        {thumbnailContent}
      </div>
    </Popover>
  )
  , [displayEdit, displayPreview, hasFragment, item.content, onClick, t, thumbnailContent])
}

export default ThumbNail
